export const validateNodeId = (id: string, projectId: string) =>
  id !== projectId ? id : null;
